import React from 'react';

const ButtonClose = ({ label = 'Close', onClick, size = 12, variant = 'black', ...rest }) => (React.createElement("button", { onClick: onClick, "aria-label": label, className: "px-2 duration-150 hover:opacity-50", ...rest }, variant === 'black' ? (React.createElement("img", { src: "/close.svg", alt: "", height: size, width: size })) : (React.createElement("img", { src: "/close-white.svg", alt: "", height: size, width: size }))));

export { ButtonClose };
//# sourceMappingURL=ButtonClose.js.map
